import React from 'react';
import { connect } from 'react-redux';
import { FontIcon, Paper, IconButton, IconMenu, FlatButton, MenuItem, RaisedButton } from 'material-ui';
import { toLaxTitleCase } from 'titlecase';
import { downloadPdfZip as downloadPdfZipAction } from '../../../../stores/contracting/contract-list/contract-list-actions';
import BulkActions from '../bulk-actions';
import FiltersSearch from './filters-search';
import R from 'ramda';


const TopBar = ({
  routeName,
  selectedContracts,
  allContractIds,
  unselectAll,
  moveAllToTrash,
  moveAllToArchived,
  restoreAll,
  restoreAllFromArchived,
  updateProps,
  stateChange,
  openBulkResendDialog,
  downloadPdfZip,
  forFiltersAndSearch,
  isFolder,
}) => {
  if (selectedContracts.length) {
    return (
      <Paper style={{ backgroundColor: 'rgb(218, 244, 247)', color: '#00bcd4', height: '49px', minHeight: '49px', display: 'flex', alignItems: 'center', fontSize: '18px' }}>
        <div style={{ width: '20%', display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={unselectAll}>
          <IconButton iconClassName="tc-icon-arrow_back" iconStyle={{ color: '#00bcd4' }} />
          Back
        </div>
        <div style={{ width: '80%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            {selectedContracts.length} item{allContractIds.length > 1 ? 's' : ''} selected
            <u
              style={{ marginLeft: '16px', fontSize: '14px', cursor: 'pointer', display: allContractIds.length > selectedContracts.length ? 'inline-block' : 'none' }}
              onClick={() => updateProps({ selectedContracts: allContractIds, allContractIds: [] })}
            >
              Select All {allContractIds.length} Item{allContractIds.length > 1 ? 's' : ''}
            </u>
          </div>
          {
            R.call(R.cond([
              [() => routeName === 'trash' || routeName === 'archived',
                R.always((<MenuItem
                  desktop
                  leftIcon={<FontIcon className="tc-icon-restore" />}
                  primaryText="Restore"
                  onTouchTap={() => {
                    if (routeName === 'trash') restoreAll(selectedContracts);
                    else restoreAllFromArchived(selectedContracts);
                  }}
                />))],
              [R.T, R.always(<BulkActions
                openManageFolderDialog={folderAction => () => updateProps({ manageFolderDialogOpen: true, selectedFolders: isFolder ? [routeName] : [], folderAction })}
                moveToTrash={() => moveAllToTrash(selectedContracts)}
                moveToArchived={() => moveAllToArchived(selectedContracts)}
                stateChange={stateChange(selectedContracts)}
                unselectAll={unselectAll}
                downloadPdfZip={downloadPdfZip}
                openBulkResendDialog={openBulkResendDialog}
              />)],
            ]))
          }
        </div>
      </Paper>
    );
  }
  return (
    <div className="flex-tc-sb" style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)', color: 'white', fontSize: '18px', minHeight: '49px' }}>
      <FiltersSearch
        {...forFiltersAndSearch}
        updateProps={updateProps}
      />
    </div>
  );
}
const mapStateToProps = ({ contracting, user }) => ({
  companyType: user.getIn(['user', 'type']),
  selectedContracts: contracting.contractList.get('selectedContracts').toJS(),
  allContractIds: contracting.contractList.get('allContractIds').toJS(),
  isFolder: contracting.contractList.get('isFolder'),
});

export default connect(mapStateToProps, ({ downloadPdfZip: downloadPdfZipAction }))(TopBar);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/top-bar/top-bar.jsx